<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Push Benachrichtigungen</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <form class="example-form">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Suche</mat-label>
                    <input matInput [formControl]="this.filterForm.controls.searchTerm" placeholder="suchen.." (keydown)="onKeydown($event)">
                </mat-form-field>
            </form>
        </div>
        <div class="col-sm-3">
            <div class="centerAndJustify">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Typ</mat-label>
                    <mat-select [formControl]="this.filterForm.controls.filterByTypes">
                        <mat-select-trigger>
                            <span *ngIf="this.filterForm.controls.filterByTypes.value != null ">
                                {{this.filterForm.controls.filterByTypes.value | translateFilterPush : 'filterByTypes'}}
                            </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let sortOption of sortOptionsState" [value]="sortOption.value">
                            {{sortOption.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row marginBottom2Rem">
        <div class="col-sm-12">
            <button mat-button mat-raised-button color="accent" (click)="filterPushMessages()"
                [disabled]="!this.filterForm.touched">
                Anwenden
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFilter()" style="margin-left: 15px;"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>


    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column w5">
                            {{i+1}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="message">
                        <th mat-header-cell *matHeaderCellDef>
                            Nachricht
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column w30" style="padding-right: 25px;">
                            {{element.message}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion/Infobeitrag
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column w30">
                            <a [routerLink]="['../event/edit', element.appLinkV2, 'advanced']"
                                *ngIf="element.type == 'EVENTS' ">
                                {{element.refTitle}}
                            </a>
                            <a [routerLink]="['../news/edit', element.refPublicId]" *ngIf="element.type == 'NEWS'">
                                {{element.refTitle}}
                            </a>
                            <span *ngIf="element.type == 'NO_REF'">
                                /
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sendingOn" class="mat-column w10">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Senden am
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span *ngIf="element.sendingOn != null ">
                                {{element.sendingOn | date:'dd.MM.yyyy HH:mm' }}
                            </span>
                            <span *ngIf="element.sendingOn == null ">
                                Noch nicht geplant
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sendOn" class="mat-column w10">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Gesendet am
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span *ngIf="element.send != null ">
                                {{element.send | date:'dd.MM.YYYY HH:mm'}}
                            </span>

                            <span *ngIf="element.send == null ">
                                Noch nicht gesendet
                            </span>

                        </td>
                    </ng-container>


                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent" >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="openEditWithData(element)" [disabled]="element.send">
                                    <span>Bearbeiten</span>
                                </button>
                                <button mat-menu-item (click)="delete(element)" [disabled]="element.send">
                                    <span>Löschen</span>
                                </button>
                                <button mat-menu-item (click)="sentInstat(element)" *ngIf="!element.send">
                                    <span>Sofort senden</span>
                                </button>
                                <button mat-menu-item (click)="duplicate(element)">
                                    <span>Duplizieren</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                    </tr>
                </table>
                <mat-paginator [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size"
                    [pageIndex]="page.number" (page)="loadPage($event)" [pageSizeOptions]="[12, 24, 36, 48]"
                    *ngIf="page">
                </mat-paginator>


            </div>

            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>